import { render, staticRenderFns } from "./LegendaTour.vue?vue&type=template&id=4bea9987&"
import script from "./LegendaTour.vue?vue&type=script&lang=js&"
export * from "./LegendaTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports